import { useEffect } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data.js'

import View from './view.js'
import { PAYOR_FILTERS } from '../constants.js'

export default function Logic(props) {
  let payment_accounts = useDataValue({
    context: 'payment_accounts',
    viewPath: props.viewPath,
  })
  let default_payment_account_id = useDataValue({
    context: 'selected',
    path: 'default_payment_account_id',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })
  let onChangeFn = useDataValue({
    context: 'selected',
    path: 'onChange',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!default_payment_account_id) return

    let payment_account = payment_accounts.find(
      item => item.data.payment_account_id === default_payment_account_id
    )
    if (!payment_account) return

    change(next => {
      // wrapped in string, to keep consistent data type, only used for dropdown
      // this is either the actual payment account id or temporary uuid
      next.payment_account.selected_id = String(payment_account.id)
      next.payment_account.data = payment_account.data

      // switch to the right tab for the payor to be visible
      next.filter =
        payment_account.data.is_new === false
          ? PAYOR_FILTERS.EXISTING
          : PAYOR_FILTERS.NEW
    })

    if (typeof onChangeFn === 'function') {
      onChangeFn(payment_account.data)
    }
  }, [default_payment_account_id]) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
